import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "webapp-popup" }
const _hoisted_2 = { class: "popup-main black" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-content" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "pwa-desc" }
const _hoisted_7 = { class: "popup-footer" }
const _hoisted_8 = { class: "flex justify-center" }
const _hoisted_9 = { class: "popup-main black" }
const _hoisted_10 = { class: "popup-header" }
const _hoisted_11 = { class: "popup-content" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "pwa-desc" }
const _hoisted_14 = { class: "popup-footer" }
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "popup-main blur" }
const _hoisted_18 = { class: "popup-header" }
const _hoisted_19 = { class: "popup-content" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "pwa-desc" }
const _hoisted_22 = { class: "popup-footer" }
const _hoisted_23 = { class: "flex justify-center" }
const _hoisted_24 = { class: "popup-main" }
const _hoisted_25 = { class: "popup-header" }
const _hoisted_26 = { class: "popup-title" }
const _hoisted_27 = { class: "popup-content" }
const _hoisted_28 = { class: "ios-guide-section" }
const _hoisted_29 = { class: "guide-step-image-wrap" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "ios-guide-section" }
const _hoisted_32 = { class: "guide-step-image-wrap" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "guide-step-text-group2" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "flex-1" }
const _hoisted_37 = { class: "app-link" }
const _hoisted_38 = ["src"]

import { ref } from 'vue';
import { useSettingsStore } from '@/store'
import { usePWA } from '@/hooks';


export default {
  __name: 'WebAppPop',
  setup(__props) {

const { installPWA } = usePWA();

const settingsStore = useSettingsStore()

const appLink = ref(window.location.origin)
const showIOSPopup = ref(false)

const goToChrome = () => {
  settingsStore.set('showGoToChrome', false);
  const protocol = window.location.protocol.replace(':', '');
  // 使用更可靠的intent协议
  const intentUrl = `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=${protocol};package=com.android.chrome;end`;
  // 尝试通过location.href跳转
  window.location.href = intentUrl;
}

const doAndroidInstall = () => {
  settingsStore.set('showAndroidWebApp', false);
  installPWA();
}

const doIOSInstall = () => {
  if (settingsStore.canPWA) {
    settingsStore.set('showIOSWebApp', false); 
    installPWA();
  } else {
    showIOSPopup.value = true;
  }
}

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_image = _resolveComponent("van-image")
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(settingsStore).showGoToChrome)
      ? (_openBlock(), _createBlock(_component_van_popup, {
          key: 0,
          show: true,
          position: "bottom",
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createVNode(_component_van_icon, {
                  class: "close-icon",
                  name: "clear",
                  onClick: _cache[0] || (_cache[0] = $event => (_unref(settingsStore).set('showGoToChrome', false)))
                }, null, 512), [
                  [_directive_audio, void 0, "close"]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_van_image, {
                    class: "logo-img",
                    src: require('@/assets/img/common/logo.png')
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('pwa.useChrome')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "continue-use",
                  onClick: _cache[1] || (_cache[1] = $event => (_unref(settingsStore).set('showGoToChrome', false)))
                }, _toDisplayString(_ctx.$t('pwa.continueH5')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                    class: "bottom-btn",
                    onClick: goToChrome
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        class: "bottom-btn-icon",
                        name: "chrome"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('pwa.openChrome')), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_audio]
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : (_unref(settingsStore).canPWA && _unref(settingsStore).showAndroidWebApp)
        ? (_openBlock(), _createBlock(_component_van_popup, {
            key: 1,
            show: true,
            position: "bottom",
            "close-on-click-overlay": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createVNode(_component_van_icon, {
                    class: "close-icon",
                    name: "clear",
                    onClick: _cache[2] || (_cache[2] = $event => (_unref(settingsStore).set('showAndroidWebApp', false)))
                  }, null, 512), [
                    [_directive_audio, void 0, "close"]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_van_image, {
                      class: "logo-img",
                      src: require('@/assets/img/common/logo.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('pwa.desc')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "continue-use",
                    onClick: _cache[3] || (_cache[3] = $event => (_unref(settingsStore).set('showAndroidWebApp', false)))
                  }, _toDisplayString(_ctx.$t('pwa.continueH5')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                      class: "bottom-btn",
                      onClick: doAndroidInstall
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SvgIcon, {
                          class: "bottom-btn-icon",
                          name: "mobile"
                        }),
                        _createTextVNode(_toDisplayString(_ctx.$t('pwa.webapp')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_audio]
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (_unref(settingsStore).showIOSWebApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_van_popup, {
            show: !showIOSPopup.value,
            position: "bottom",
            "close-on-click-overlay": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createVNode(_component_van_icon, {
                    class: "close-icon",
                    name: "clear",
                    onClick: _cache[4] || (_cache[4] = $event => (_unref(settingsStore).set('showIOSWebApp', false)))
                  }, null, 512), [
                    [_directive_audio, void 0, "close"]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_van_image, {
                      class: "logo-img",
                      src: require('@/assets/img/common/logo.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('pwa.ios.desc')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: "continue-use",
                    onClick: _cache[5] || (_cache[5] = $event => (_unref(settingsStore).set('showIOSWebApp', false)))
                  }, _toDisplayString(_ctx.$t('pwa.continueH5')), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                      class: "bottom-btn",
                      onClick: doIOSInstall
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SvgIcon, {
                          class: "bottom-btn-icon fix-position",
                          name: "apple"
                        }),
                        _createTextVNode(_toDisplayString(_ctx.$t('pwa.webapp')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_audio]
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_van_popup, {
            show: showIOSPopup.value,
            position: "bottom",
            "close-on-click-overlay": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('pwa.ios.title')), 1),
                  _withDirectives(_createVNode(_component_van_icon, {
                    class: "close-icon",
                    name: "cross",
                    onClick: _cache[6] || (_cache[6] = $event => (_unref(settingsStore).set('showIOSWebApp', false)))
                  }, null, 512), [
                    [_directive_audio, void 0, "close"]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title" }, "1. Tap on the 'More' icon and then tap on Add to Home Screen", -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("img", {
                        class: "guide-step-image",
                        src: require('@/assets/img/pwa/ios1.png'),
                        alt: "step"
                      }, null, 8, _hoisted_30),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "guide-step-text-group1" }, [
                        _createElementVNode("div", { class: "guide-img-text" }, "Add to Quick Note"),
                        _createElementVNode("div", { class: "guide-img-text" }, "Find on Page"),
                        _createElementVNode("div", { class: "guide-img-text" }, "Add to Home Screen"),
                        _createElementVNode("div", { class: "guide-img-text" }, "Markup")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "section-title" }, "2. Click to add, select 'Add'", -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("img", {
                        class: "guide-step-image",
                        src: require('@/assets/img/pwa/ios2.png'),
                        alt: "guide"
                      }, null, 8, _hoisted_33),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "guide-step-text-group2--header" }, [
                          _createElementVNode("div", { class: "guide-img-text" }, "Cancel"),
                          _createElementVNode("div", { class: "guide-img-text bold" }, "Add")
                        ], -1)),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_van_image, {
                            class: "logo-img",
                            src: require('@/assets/img/common/logo.png')
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_36, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "app-name" }, "GBET.COM", -1)),
                            _createElementVNode("div", _hoisted_37, _toDisplayString(appLink.value), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("img", {
                      class: "down-pointer",
                      src: require('@/assets/img/pwa/hand.png'),
                      alt: "pointer"
                    }, null, 8, _hoisted_38)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}